import { fetcher } from '@commenda/utils';

interface CAFirmMemberInputProp {
  name: string;
  email: string;
}

export default async function addCAFirmMembers({
  data,
  token,
  caFirmId,
}: {
  data: CAFirmMemberInputProp;
  token: string;
  caFirmId: string;
}) {
  try {
    const res = await fetcher(
      `caFirm/${caFirmId}/member`,
      {
        method: 'POST',
        body: data,
      },
      token
    );

    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
}
